import React from "react";
import styled from "styled-components";

const Text = styled.span`
  color: var(--dark-gray);
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: normal;
  width: 100%;
`;

const FieldHelperText = ({ children }) => {
  return <Text>{children}</Text>;
};

export default FieldHelperText;
